import { Link, useLocation } from "react-router-dom";
import AdminShell from "@/components/admin/AdminShell";
import { QuickSearch } from "@/components/si/QuickSearch";
import { SI } from "@/lib/sourcing";

export default function SIQuick() {
  const { search } = useLocation();
  return (
    <AdminShell area="si" title="Quick People Search" subtitle="Find real people on LinkedIn and GitHub without setting up a project, then add the best ones to a project.">
      <div className="space-y-4" data-testid="si-quick-page">
        <Link to={SI} className="text-xs text-zinc-500 hover:text-[#D4AF37]" data-testid="si-quick-back">← All sourcing projects</Link>
        <QuickSearch key={search} />
      </div>
    </AdminShell>
  );
}
